/* eslint-disable max-lines*/
/* eslint-disable max-statements*/
/* eslint-disable xss/no-mixed-html*/
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */

PHI.shoppinglistpopup = {
  // eslint-disable-next-line max-params, complexity
  loadProductAtpData: function(data, listNameWithoutSpace1, shoplistParent, ordrDetailsStr, listQty) {
    var listncode = data.code,
        qtyBoxVal = $('#' + listNameWithoutSpace1 + '-' + data.code).val(),
        $parentId = $('#' + shoplistParent + ' ' + ordrDetailsStr + listNameWithoutSpace1),
        maxStock = parseInt(data.atpData.lowStockQty, 10),
        disabledLen = '',
        errorTextmsg = $parentId.find('.ph-lognostkerrormsg'),
        availStatus = data.atpData.availabilityCode,
        outOfStockStatus = $('.ph-availstatus').val(),
        // eslint-disable-next-line id-match
        dchain30FutureInStock = $('#ph-dchain30FutureInStock').val(),
        // eslint-disable-next-line id-match
        dchain30FutureLowStock = $('#ph-dchain30FutureLowStock').val(),
        // eslint-disable-next-line id-match
        dchain50NoStock = $('#ph-dchain50NoStock').val(),
        notavailmsgshop = 'not-avail-msg',
        // eslint-disable-next-line id-match
        isFreeMarketingProductFromATP = data.isFreeMarketingProduct,
        disablebtnn = 'ph-disable-button',
        listbackordertoggle = $('#ph-backorderfeaturetoggle').val(),
        maxQtyEnabled = $('#ph-maxQtyEnabled').val(),
        parentdiv = ordrDetailsStr + listNameWithoutSpace1,
        verylightgreen = '.very-light-green',
        dChainProductToggle = $('.ph-dchain-product-toggle').val(),
        dChainProductValue = data.dchainValue,
        dChainProdValidFrom = data.validFrom,
        dChainFirstEntry = ACC.common.getDChainFirstEntry(data),
        // eslint-disable-next-line no-negated-condition, no-ternary
        dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
        // eslint-disable-next-line no-negated-condition, no-ternary, compat/compat
        dChainFirstEntryQty = dChainFirstEntry !== null ? parseInt(Object.values(dChainFirstEntry)[0], 0) : '',
        outOfStockCls = '#row' + data.code + ' .ph-not-avail-msg',
        lowStockCls = '#row' + data.code + ' .ph-shplist-stkavail';

    $parentId.find('#row' + data.code + ' ' + listQty).attr('data-maxqty', maxStock).attr('data-availstate', availStatus);

    if (listbackordertoggle === 'true') {
      if (availStatus === 'red') {
        $parentId.find('#row' + data.code + ' .ph-' + notavailmsgshop).addClass('ph-orange-msg').html(outOfStockStatus);
        $parentId.find('#row' + data.code + ' .ph-' + notavailmsgshop).removeClass('hidden');
        $parentId.find('#row' + data.code + ' ' + listQty).val('0').attr('disabled', 'disabled');
        $parentId.find('#row' + data.code + ' .ph-list_plusminus').attr('disabled', 'disabled');
        ACC.autocomplete.disableEnableErrormsg(disabledLen, errorTextmsg, parentdiv);
      } else {
        ACC.autocomplete.backorderAvailQtyCheck(qtyBoxVal, maxStock, data.code, parentdiv);
      }

      ACC.autocomplete.checkForItemLevelErrors(listNameWithoutSpace1);
    } else if (listbackordertoggle === 'false' && maxQtyEnabled === 'false') {
      if ($(disablebtnn).length > 0) {
        $(verylightgreen).attr('disabled', 'disabled');
        $(verylightgreen).addClass(disablebtnn);
      }
    }

    /* Dchain implementation start */
    /* eslint-disable unicorn/no-fn-reference-in-iterator */
    if (dChainProductToggle === 'true' && dChainProductValue !== '' && dChainProductValue !== null) {
      if (dChainProductValue === '30') {
        if ((listbackordertoggle === 'false' &&
          ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate)) ||
          ((listbackordertoggle === 'true') &&
          (data.atpData.availabilityCode === 'green' || data.atpData.availabilityCode === 'orange') &&
          ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))
        ) {
          $parentId.find('.myshopping-list-viewfulllist').removeClass('ph-disable-button');
        } else if ((listbackordertoggle === 'true' && data.atpData.availabilityCode === 'red') ||
          !(ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))
        ) {
          $parentId.find('#row' + data.code + ' ' + listQty).val('0').attr('disabled', 'disabled');
          $parentId.find('#row' + data.code + ' .ph-list_plusminus').attr('disabled', 'disabled');
          $parentId.find('#row' + data.code).append('<div class="ph-dchain-shoppinglist-error hidden"></div>');
          $parentId.find(outOfStockCls).removeClass('hidden').addClass('ph-orange-msg').html(outOfStockStatus);

          if ((data.atpData.availabilityCode === 'green' || data.atpData.availabilityCode === 'orange') &&
            !(ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))) {
            if (data.atpData.availabilityCode === 'green') {
              $parentId.find(outOfStockCls).addClass('hidden');
              $parentId.find(lowStockCls).addClass('ph-hidepopup');
              $parentId.find('#row' + data.code + ' .ph-not-avail-msg-30-future-instock').removeClass('hidden').html(dchain30FutureInStock);
            } else if (data.atpData.availabilityCode === 'orange') {
              $parentId.find(outOfStockCls + ' , ' + lowStockCls).addClass('hidden');
              $parentId.find('#row' + data.code + ' .ph-not-avail-msg-30-future-lowstock').removeClass('hidden').html(dchain30FutureLowStock);
            }
          }
        }
      } else if (dChainProductValue === '50') {
        // eslint-disable-next-line max-len
        if ((data.atpData.availabilityCode === 'red') || (!ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate) && (dChainFirstEntryQty === '' || dChainFirstEntryQty <= 0))) {
          $parentId.find(outOfStockCls).addClass('hidden');
          $parentId.find(lowStockCls).addClass('ph-hidepopup');
          $parentId.find('#row' + data.code + ' ' + listQty).val('0').attr('disabled', 'disabled');
          $parentId.find('#row' + data.code + ' .ph-list_plusminus').attr('disabled', 'disabled');
          $parentId.find('#row' + data.code).append('<div class="ph-dchain-shoppinglist-error hidden"></div>');
          $parentId.find('#row' + data.code + ' .ph-not-avail-msg-50-nostock').removeClass('hidden').html(dchain50NoStock);
        }
      }
    }
    /* eslint-enable unicorn/no-fn-reference-in-iterator */
    /* Dchain implementation end */

    if (!(listbackordertoggle === 'true' && availStatus === 'red') && (maxQtyEnabled === 'true' || isFreeMarketingProductFromATP)) {
      $('.ph-qty-' + listncode).on('input', ACC.autocomplete.checkInputValue(listncode, listbackordertoggle, qtyBoxVal, parentdiv, maxQtyEnabled));
    }

    ACC.autocomplete.checkAndEnableOrDisableAddtoCartBtn($('#' + listNameWithoutSpace1 + '-' + data.code).closest('.ph-shoppinglistmain'));
  }
};

$(document).ready(function() {
  function trackConversion(name, description) {
    if (typeof philips.analytics !== 'undefined') {
      philips.analytics.trackConversion({
        name: name,
        description: description
      });
    }
  }

  /* eslint-disable id-match */
  $(function() { // NOSONAR
    var listTableProd = 'list-names-tbl-prd',
        myshopMain = '.myshopping-',
        $acc = $(myshopMain + listTableProd),
        listQty = '.ph-quantity';

    $($acc).each(function() {
      $(this).click(function() {
        var itemName = '',
            isActive = '',
            panel = '',
            listNameWithoutSpace1 = '',
            listname = '',
            shoplistParent = '',
            iconUpArrow = 'ph-icon-arrow-up',
            iconDownArrow = 'ph-icon-arrow-down',
            ordrDetailsStr = '#ph-order-details-';

        if ($('.myshopping-list-names-tbl-prd.active').length > 0) {
          itemName = $('.myshopping-list-names-tbl-prd.active').html();
          trackConversion('interaction', itemName + ' - Close');
          $(this).parent().prev().removeClass(iconUpArrow).addClass(iconDownArrow);
        }

        // Toggle of pannel starts here
        /* eslint-disable no-undef */
        isActive = jQuery.inArray('active', this.classList);
        /* eslint-enable no-undef */
        panel = $(this).siblings()[0];

        $(myshopMain + listTableProd).removeClass('active');
        $('.ph-panel').css('max-height', 0);

        if (isActive === -1) {
          $(this).toggleClass('active');

          /* eslint-disable no-negated-condition */
          if (panel.style.maxHeight !== '0px') {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + '30px';
          }

          /* eslint-enable no-negated-condition */
          listname = $(this).html();
          listNameWithoutSpace1 = listname.replace(/\s+/g, '');
          shoplistParent = $(this).parent().parent().attr('id');
          $(myshopMain + listTableProd).parent().prev().removeClass(iconUpArrow).addClass(iconDownArrow);
          $(this).parent().prev().removeClass(iconDownArrow).addClass(iconUpArrow);
          trackConversion('interaction', listname + ' - Open');
          // Hit server and get list of products from server
          $.ajax({
            url: ACC.config.encodedContextPath + '/shoppinglist/viewShoppingListPopup',
            data: {
              orderName: listname
            },
            type: 'POST',
            datatype: 'json',
            success: function(result) {
              var productCount1 = 0,
                  listbackordertoggle = '',
                  $listlogn12nccode = '',
                  obj = $.parseJSON(JSON.stringify(result)),
                  disBtnStr = 'disable-button',
                  disablebtnn = 'ph-' + disBtnStr,
                  myshoppinglistbuttonn = '.myshopping-list-button-',
                  orderdet = '-order-details-',
                  listCountProd = 'listProductCount',
                  arr = [],
                  productCount = 0,
                  popLength = 0,
                  codeExists = '',
                  ind = 0;

              // Load the products to div
              $('#' + shoplistParent + ' #ph' + orderdet + listNameWithoutSpace1).html(obj.shoppingListPopup);
              $('.ph-checkallproducts').trigger('click');

              ACC.quotation.checkForBlockedProductsOnLoad();
              // If product is not there disabling the Add List to Cart Button
              productCount1 = parseInt($('#ph-' + listCountProd + listNameWithoutSpace1).val(), 10);

              if (productCount1 === 0) {
                $(myshoppinglistbuttonn + listNameWithoutSpace1).addClass(disablebtnn);
              } else {
                ACC.autocomplete.disableSAPEnableBtn(myshoppinglistbuttonn + listNameWithoutSpace1, disablebtnn);
              }

              listbackordertoggle = $('#ph-backorderfeaturetoggle').val();
              $listlogn12nccode = $('#' + shoplistParent + ' .product-container .productcode');

              productCount = $('#ph-listProductCount' + listNameWithoutSpace1).val();
              popLength = $('.ph-hidepopup').length;

              $(listQty).each(function() {
                arr.push($(this).val());
              });

              for (ind; ind < arr.length; ind = ind + 1) {
                if (arr[ind] > '0') {
                  codeExists = true;

                  break;
                } else {
                  codeExists = false;
                }
              }

              if ((codeExists === true) && (productCount1 > 0)) {
                ACC.autocomplete.disableSAPEnableBtn(myshoppinglistbuttonn + listNameWithoutSpace1, disablebtnn);
              } else if ((popLength !== productCount) && (listbackordertoggle === true)) {
                $(myshoppinglistbuttonn + listNameWithoutSpace1).addClass(disablebtnn);
              } else {
                $(myshoppinglistbuttonn + listNameWithoutSpace1).addClass(disablebtnn);
              }

              $($listlogn12nccode).each(function() {
                var listncode = $(this).val();

                PHI.common.getAtpData(listncode, function(data) {
                  PHI.shoppinglistpopup.loadProductAtpData(data, listNameWithoutSpace1, shoplistParent, ordrDetailsStr, listQty);
                });
              });
              // Implementation of back-order code ends
            },
            error: function() {
              $(ordrDetailsStr + listNameWithoutSpace1).html('');
            }
          });
        }
      });
    });
  });
});
/* eslint-enable id-match */
$(document).ready(function() {
  var latestName = '',
      fieldNamePlus = '',
      fieldNameMinus = '',
      currentVal = '',
      maxValue = '',
      minValue = '';

  if ($('.ph-disablebutton').length > 0) {
    $('.ph-addtocart').addClass('ph-disable-button');
  }

  $(document).on('click', '.ph-editlistbtn', function() {
    var listname = $(this).attr('data-listname'),
        myShopListProd = '.myshopping-list-names-tbl-prd-';

    $(myShopListProd + listname).click();
    $(myShopListProd + listname).click();
    setTimeout(function() {
      $.colorbox({
        html: $('.ph-editlistpopup-' + listname).html(),
        maxWidth: '485',
        width: '90%',
        height: 'auto',
        overlayClose: false,
        onClosed: function() {
          $('.ph-editlistpopup').addClass('hidden');
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    }, 200);
    $(myShopListProd + listname).trigger('click');
    $(myShopListProd + listname).trigger('click');
  });

  $(document).on('click', '#cboxLoadedContent .ph-deletePopup', function() {
    $.colorbox({
      width: '500px',
      maxWidth: '90%',
      height: '200px',
      html: $('.ph-popupConfirm').html(),
      overlayClose: false,

      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });

  $(document).on('keyup', '#cboxLoadedContent .ph-favshoplistinput', function() {
    latestName = $(this).val();
    latestName = latestName.replace(/\s{2,}/g, ' ');
    latestName = latestName.trim();
  });

  $(document).on('click', '#cboxLoadedContent .ph-updatebutton', function() {
    var existingList = $(this).attr('data-listname');

    if ((/[&\\#,+()=|`$@!~%.'":*?^<>{}]/g).test(latestName) === true) {
      $.colorbox.close();
      $('.ph-emptyListName').show();
    }

    if (existingList === latestName || latestName === '') {
      $.colorbox.close();
      location.reload();
    } else {
      $.ajax({
        url: ACC.config.encodedContextPath + '/shoppinglist/updateWishList',
        data: {
          oldListName: existingList,
          newListName: latestName
        },
        type: 'GET',
        datatype: 'json',
        success: function(result) {
          if (result === 'Success') {
            location.reload();
          } else if (result === 'Failure') {
            $.colorbox.close();
            $('.ph-emptyListName').show();
          }
        },
        error: function() {
          $('.myshopping-list-product-name').html('');
        }
      });
    }
  });

  $(document).on('click', '.ph-list_qtyplus', function(event) {
    event.preventDefault();

    fieldNamePlus = $(this).attr('field');
    currentVal = parseInt($('#' + fieldNamePlus).val(), 10);
    maxValue = parseInt($('#' + fieldNamePlus).attr('max'), 10);

    if (maxValue > currentVal) {
      $('#' + fieldNamePlus).val(currentVal + 1).trigger('blur');
    }
  });

  $(document).on('click', '.ph-list_qtyminus', function(event) {
    event.preventDefault();

    fieldNameMinus = $(this).attr('field');
    currentVal = parseInt($('#' + fieldNameMinus).val(), 10);
    minValue = parseInt($('#' + fieldNameMinus).attr('min'), 10);

    if (minValue < currentVal) {
      $('#' + fieldNameMinus).val(currentVal - 1).trigger('blur');
    }
  });
});


$(document).ready(function() {
  var updatedValue = '',
      productCount = 0,
      disablebtnn = 'ph-disable-button',
      listUpdatedqty = 'quantity',
      shoplistBtn = '.myshopping-list-button-';
  /* eslint-disable complexity*/

  $(document).on('keyup blur', '.ph-' + listUpdatedqty, function() {
    var inputVal = $(this).val(),
        maxStock = $(this).attr('data-maxqty'),
        availStatus = $(this).attr('data-availstate'),
        parentShopId = $(this).parents('.myshoppinglist-name').attr('id'),
        rowId = $(this).parents('.ph-myshopping-list-row').attr('id'),
        prodCode = $('#' + parentShopId + ' #' + rowId).find('.productcode').val(),
        backorderFlag = $('#ph-backorderfeaturetoggle').val(),
        quantity = Number($(this).val()),
        listname = $(this).attr('data-qtylistname'),
        codeExists = '',
        listNameWithoutSpace = listname.replace(/\s+/g, ''),
        orderMeDetails = 'order-details-',
        parentdiv = '#ph-' + orderMeDetails + listNameWithoutSpace,
        hidePopupString = 'hidepopup',
        hidePopup = $('.ph-' + hidePopupString).length,
        arr = [],
        ind = 0,
        inputMinValue = $(this).attr('min'),
        maxQtyEnabled = $('#ph-maxQtyEnabled').val(),
        isFreeMarketingProduct = $(this).closest('.ph-myshopping-list-row').find('.ph-is-free-marketing-product').val();

    updatedValue = $(this).val();
    productCount = parseInt($('#ph-listProductCount' + listNameWithoutSpace).val(), 10);


    $('.ph-' + listUpdatedqty).each(function() {
      arr.push($(this).val());
    });

    for (ind; ind < arr.length; ind = ind + 1) {
      if (arr[ind] > '0') {
        codeExists = true;

        break;
      } else {
        codeExists = false;
      }
    }


    if ((updatedValue === inputMinValue) && (productCount <= 1)) {
      $(shoplistBtn + listNameWithoutSpace).addClass(disablebtnn);
    } else if (parseInt(updatedValue, 10) > parseInt(maxStock, 10)) {
      $(shoplistBtn + listNameWithoutSpace).addClass(disablebtnn);
    } else if ((updatedValue !== inputMinValue) && (codeExists === true) &&
               (parseInt(updatedValue, 10) <= parseInt(maxStock, 10)) && (hidePopup === productCount)) {
      ACC.autocomplete.disableSAPEnableBtn(shoplistBtn + listNameWithoutSpace, disablebtnn);
    } else if ((updatedValue === inputMinValue) && (codeExists === false)) {
      $(shoplistBtn + listNameWithoutSpace).addClass(disablebtnn);
    } else if ($('#ph-' + orderMeDetails + listNameWithoutSpace).find('.ph-shplist-stkavail:visible').length > 0) {
      ACC.autocomplete.disableSAPEnableBtn(shoplistBtn + listNameWithoutSpace, disablebtnn);
    } else if ($('#ph-' + orderMeDetails + listNameWithoutSpace).find('.ph-lognostkerrormsg:visible').length > 0) {
      ACC.autocomplete.disableSAPEnableBtn(shoplistBtn + listNameWithoutSpace, disablebtnn);
    } else if ($('#ph-' + orderMeDetails + listNameWithoutSpace).find('.ph-isblocked-msgs:visible').length > 0) {
      ACC.autocomplete.disableSAPEnableBtn(shoplistBtn + listNameWithoutSpace, disablebtnn);
    } else if ($('#ph-' + orderMeDetails + listNameWithoutSpace).find('.ph-productMaxQty_popupMsgError:visible').length > 0) {
      ACC.autocomplete.disableSAPEnableBtn(shoplistBtn + listNameWithoutSpace, disablebtnn);
    } else if ($('#ph-' + orderMeDetails + listNameWithoutSpace).find('.ph-annualMaxQtyMsg:visible').length > 0) {
      ACC.autocomplete.disableSAPEnableBtn(shoplistBtn + listNameWithoutSpace, disablebtnn);
    } else {
      $(shoplistBtn + listNameWithoutSpace).removeClass(disablebtnn);
    }

    $.ajax({
      url: ACC.config.encodedContextPath + '/shoppinglist/updateProductQuantity',
      data: {
        shoppingListName: listname,
        productCode: prodCode,
        quantity: quantity
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        var obj = $.parseJSON(JSON.stringify(result));
        /* eslint-disable  no-use-before-define*/
        var updatedQuantity = getQuantityByCode(prodCode, obj);

        /* eslint-enable  no-use-before-define*/

        $(this).val(updatedQuantity);
      },
      error: function() {
        var qtyemt = '-quantity';

        $('.ph' + qtyemt).html('');
      }
    });

    if (backorderFlag === 'true' && availStatus !== 'red') {
      ACC.autocomplete.backorderAvailQtyCheck(inputVal, maxStock, prodCode, parentdiv);
      ACC.autocomplete.checkForItemLevelErrors(listNameWithoutSpace);
    } else if (backorderFlag === 'false' && availStatus !== 'red') {
      ACC.autocomplete.checkForItemLevelErrors(listNameWithoutSpace);
    }

    if (!(backorderFlag === 'true' && availStatus === 'red') && (maxQtyEnabled === 'true' || isFreeMarketingProduct === 'true')) {
      $('.ph-qty-' + prodCode).on('input', ACC.autocomplete.checkInputValue(prodCode, backorderFlag, inputVal, parentdiv, maxQtyEnabled));
    }

    ACC.autocomplete.checkAndEnableOrDisableAddtoCartBtn($(this).closest('.ph-shoppinglistmain'));
  });

  $(document).on('keyup', '.ph-' + listUpdatedqty, function() {
    var quantity = Number($(this).val());

    if (!quantity) {
      quantity = 0;
      $(this).val(quantity);
    }
  });

  function getQuantityByCode(code, data) {
    var qty = 0;

    data.shoppingListEntryData.forEach(function(item) {
      if (code === item.product.code) {
        qty = item.quantity;
      }
    });

    return qty;
  }
});
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
/* eslint-enable max-lines*/
/* eslint-enable max-statements*/
/* eslint-enable xss/no-mixed-html*/
/* eslint-enable complexity*/

